import axios from "axios";
import Config from "../utils/Config";
import Middleware from "./Middleware";

class CommitteeService {

    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
    }

    async getCommitteeById(committeeId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.get(
            `/api/committee/byId/${committeeId}`,
            this.config
        )
        return res;
    }
    
    async getCommitteesByCommitteeTypeIdWithMeetingPermission(committeeId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.get(
            `/api/committee/byCommitteeTypeWithMeetingPermission/${committeeId}`,
            this.config
        )
        return res;
    }
    
    async getCommitteesByCommitteeType(committeeId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.get(
            `/api/committee/byCommitteeType/${committeeId}`,
            this.config
        )
        return res;
    }

    async getCommitteeTypeByUserDetailsId(userDetailsId, companyId, accessToken){
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.get(
            `/api/committeeType/byUserDetailsId/forPrivileged`,
            this.config
        )
        return res;
    } 
    
    async getCommitteedataByTypeAndUserDetailsId(committeeTypeId, companyId, accessToken){
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.get(
            `/api/committee/byCommitteeTypeAndUserDetailsId/${committeeTypeId}/forPrivileged`,
            this.config
        )
        return res;
    }
}

export default new CommitteeService();
